module.exports = __webpack_public_path__ + "img/damDeflated.7040546c.svg";